import { HTMLAttributes, useState } from 'react'
import cslx, { clsx } from 'clsx'

type ImagesGalleryProps = {
  images: string[]
  className?: HTMLAttributes<HTMLDivElement>["className"]
}

export function ImagesGallery (props: ImagesGalleryProps) {
  const { images, className } = props

  const [selectedImage, setSelectedImage] = useState(0)

  return (
    <div className={clsx("flex flex-col", className)}>
      <img
        alt="img"
        src={images[selectedImage]}
        className="rounded-2xl object-cover w-full h-[200px] md:w-auto md:h-[400px]"
      />

      {images.length > 1 &&
        <div className="grid grid-cols-3 gap-4 py-6">
          {images.map((image, index) => (
            <img
              alt="img"
              onClick={() => setSelectedImage(index)}
              key={index}
              src={image}
              className={
                cslx(
                  'rounded-2xl h-30 md:h-50 object-cover',
                  {
                    'outline-2 outline-secondary-content': index === selectedImage,
                    'hover:outline-2 hover:outline-secondary-content/50': index !== selectedImage
                  }
                )
              }
            />
          ))}
        </div>}
    </div>
  )
}
